<template>
    <DialogueBox :blur="true" :height="709" :width="752" :top="71" :left="264">

        <div class="round_title" v-html="T('round_results')"></div>
        <div class="round-text">
            <div v-html="P1"></div>
            <div v-html="P2"></div>
        </div>
        <div class="report-speech-tick"></div>

        <b-container class="playerGrid">

            <b-row>

                <template v-for="(playerState, playerId) in game.playerStates">
                    <b-col cols="6" class="playerCard" v-bind:key="'playerReportFor' + playerId">
                        <AvatarCircle :size="66" :sizeInner="45" :id="playerId + ''" :isSelected="false"
                            :selectable="false" :isReserved="false" class="avatar-circle">
                        </AvatarCircle>
                        <div class="text-container">
                            <div class="player-name" v-html="realName(playerId)"></div>
                            <div v-for="(action, actionId) in getActions(playerState)"
                                v-bind:key="'action' + actionId + 'in' + playerId" v-html="action">
                            </div>
                        </div>
                    </b-col>
                </template>

            </b-row>

        </b-container>
        <!--Button to roll dice-->
        <button class="btn-base roll_BTN" @click="$emit('roll-dice')" v-html="NextButtonText"></button>
        <div class="facilitator"></div>
    </DialogueBox>
</template>

<script lang="ts">
import { T } from '@/App.vue';
import Vue, { PropType } from 'vue';
import DialogueBox from "./DialogueBox.vue";
import Game from '../../../shared_fca/game';
import AvatarCircle from './AvatarCircle.vue';
import { users } from '../../../shared_fca/room_user';
import playerState, { getRoundReport } from '../../../shared_fca/playerstate';
import { maxRounds, skipFinalDiceRoll } from '@/configuration';

export default Vue.extend({
    name: 'RoundResults',
    props: {
        game: Object as PropType<Game>,
        offline: Boolean,
        playerState: Object as PropType<playerState>,
    },
    components: {
        DialogueBox,
        AvatarCircle
    },
    computed: {

        NextButtonText: {
            cache: false,
            get(): string {

                if (this.playerState.round + 1 >= maxRounds && skipFinalDiceRoll) {
                    return T("button_endjourney");
                }

                return T('button_roll_dice');
            }
        },

        Round: {
            cache: false,
            get(): number {
                return (this.playerState.round + 1);
            }
        },

        P1: {
            cache: false,
            get(): string {

                return T('Results_' + this.Round + '_key_message') + "\n\n";

            }
        },
        P2: {
            cache: false,
            get(): string {

                if (this.offline) {
                    return T('Results_paragraph_2_singleplayer_' + this.Round);
                }
                else {
                    return T('Results_paragraph_2_multiplayer_' + this.Round);
                }

            }
        }
    },
    methods: {
        T(key: string): string {
            return T(key);
        },
        realName(key: string | number) {
            return this.T(users[key].realname);
        },
        getActions(playerState: playerState): string[] {
            return getRoundReport(playerState, this.T, this.playerState.round, "- ");
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/*CSS here*/
* {
    font-family: Rubik, sans-serif;
    font-weight: 400;
}

.report-speech-tick {
    width: 94.87px;
    height: 90.11px;
    top: 256.56px;
    right: 684.13px;
    position: absolute;
    background-size: cover;
    background-image: url("../assets-fca/Speech Bubbles/report-speech-tick.svg");
}

.avatar-circle {
    position: absolute;
}

.player-name {
    color: #333333;
    font-family: Rubik;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    font-weight: bold;
}

.text-container {
    margin-left: 92px;
}

.playerCard {
    min-height: 88px;
}

.playerGrid {
    width: 637px;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    left: 42px;
    top: 252px;
}

.round_title {
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #636252;
    height: 36px;
    top: 57px;
    left: 53.07px;
    position: absolute;
}

.round-text {
    width: 650px;
    top: 107px;
    left: 53.07px;
    position: absolute;
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #333333;
}

.round_p1 {
    width: 100%;
    color: #333333;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
    padding-left: 44px;
    padding-right: 44px;
    margin-top: 21px;
}

.round_p1 {
    top: 80px;
}

.round_p2 {
    top: 150px;
}

/*dice roll button*/
.roll_BTN {

    position: absolute;
    width: 162px;
    height: 50px;
    bottom: 33px;
    right: 43px;
    border-radius: 8px;
    border:0px;

    background-color: #B2CD30;
    color: #FFFFFF;

}

.facilitator {
    width: 270px;
    height: 344px;
    top: 289px;
    left: -267px;
    position: absolute;
    background-size: cover;
}
</style>
